import s from './SentEmails.scss'
import MaterialTable from '@material-table/core'
import { PageTitle } from 'components/common/PageTitle'
import { makeGetRequest } from 'utils/api'
import { toEmails } from './serializers'
import { getNoBidClientStyle } from 'utils/helpers'

const columns = [
  {
    title: 'Attempt Date',
    field: 'date',
    defaultSort: 'desc'
  },
  { title: 'Attempt Time', field: 'time' },
  { title: 'Status', field: 'status' },
  { title: 'Error', field: 'error' },
  { title: 'Sent Date', field: 'sentDate', sorting: false },
  { title: 'Sent Time', field: 'sentTime', sorting: false },
  { title: 'Sent To', field: 'sentTo' },
  { title: 'Contact', field: 'contact' },
  {
    title: 'Company',
    field: 'company',
    render: row => <span style={getNoBidClientStyle(row.companyNoBid)}>{row.company}</span>
  },
  { title: 'Subject Line', field: 'subjectLine' },
  { title: 'Opportunity(opportunities)', field: 'dealName' },
  { title: 'Proposal(s)', field: 'proposalName' }
]

const SentEmails = () => {
  const getData = async query => {
    const { page, pageSize, orderBy, orderDirection, search } = query
    const response = await makeGetRequest(
      `/v1/email/sent?page=${page}&size=${pageSize}&sortByColumn=${
        orderBy ? (orderBy?.field ?? 'date') : ''
      }&sortByValue=${orderDirection || 'desc'}&filterBy=${search}`
    )
    return {
      data: toEmails(response.content),
      page: response.number,
      totalCount: response.totalElements
    }
  }
  return (
    <>
      <PageTitle view="Sent Emails" />
      <div className={s.wrapper}>
        <MaterialTable
          title="Emails you sent from Ideal CRM and their status"
          columns={columns}
          data={query => getData(query)}
          options={{
            sorting: true,
            debounceInterval: 500,
            headerStyle: {
              backgroundColor: '#eee',
              color: '#000',
              position: 'sticky',
              top: 0,
              zIndex: 1,
              fontSize: '14px'
            },
            maxBodyHeight: '700px',
            pageSize: 20,
            padding: 'dense'
          }}
          style={{
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            fontSize: '14px'
          }}
        />
      </div>
    </>
  )
}

export default SentEmails
